// extracted by mini-css-extract-plugin
module.exports = {"slide":"Slide_slide__jccAo","show":"Slide_show___CbTF","hide":"Slide_hide__zbSTv"};